import React from "react";
import NavItem from "./navItem";

const SubMenu = ({
  clientName,
  seeTimesheets = false,
  seeBookings = false
}) => {
  if (clientName === "regatta") {
    return (
      <div className="tw-border-b container tw-border-gray-200 tw-pb-8">
        <div
          style={{
            backgroundColor: `lightslategray`
          }}
        >
          <ul className="container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-md tw-text-center tw-text-white">
            <NavItem
              to="/documentationREG"
              pathName="Onboarding"
              display={true}
            />
            <NavItem
              to="/regatta-starters"
              pathName="Starters Report"
              display={true}
            />
            <NavItem
              to="/regatta-absenses"
              pathName="Absences Report"
              display={true}
            />
            <NavItem
              to="/regatta-attrition"
              pathName="Attrition Report"
              display={true}
            />
            <NavItem
              to="/regatta-leavers"
              pathName="Leavers Report"
              display={true}
            />
          </ul>
        </div>
      </div>
    );
  }
  if (clientName === "resources") {
    return (
      <div className="tw-border-b container tw-border-gray-200 tw-pb-8">
        <div
          style={{
            backgroundColor: `lightslategray`
          }}
        >
          <ul className="container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-md tw-text-center tw-text-white">
            <NavItem
              to="/resources"
              pathName="Resource Management"
              display={true}
            />
            {seeTimesheets && (
              <NavItem to="/timesheets" pathName="Timesheets" display={true} />
            )}
            {seeBookings && (
              <NavItem to="/vacancies" pathName="Vacancies" display={true} />
            )}
          </ul>
        </div>
      </div>
    );
  }
  if (clientName === "ipn") {
    return (
      <div className="tw-border-b container tw-border-gray-200 tw-pb-8">
        <div
          style={{
            backgroundColor: `lightslategray`
          }}
        >
          <ul className="container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-md tw-text-center tw-text-white">
            <NavItem to="/ipn-report" pathName="IPN Report" display={true} />
            <NavItem
              to="/ipn-induction"
              pathName="IPN Site Induction"
              display={true}
            />
          </ul>
        </div>
      </div>
    );
  }
  if (clientName === "greatBear") {
    return (
      <div className="tw-border-b container tw-border-gray-200 tw-pb-8">
        <div
          style={{
            backgroundColor: `lightslategray`
          }}
        >
          <ul className="container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-md tw-text-center tw-text-white">
            <NavItem
              to="/documentationGB"
              pathName="Onboarding"
              display={true}
            />
            <NavItem
              to="/great-bear-report"
              pathName="Tenure Report"
              display={true}
            />
          </ul>
        </div>
      </div>
    );
  }
  if (clientName === "financial") {
    return (
      <div className="tw-border-b container tw-border-gray-200 tw-pb-8">
        <div
          style={{
            backgroundColor: `lightslategray`
          }}
        >
          <ul className="container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-md tw-text-center tw-text-white">
            <NavItem to="/financials" pathName="Reports" display={true} />
            <NavItem
              to="/credit-summary"
              pathName="Credit Summary Report"
              display={true}
            />
            <NavItem
              to="/worker-summary"
              pathName="Worker Summary Report"
              display={true}
            />
          </ul>
        </div>
      </div>
    );
  }
  if (clientName === "speciality-breads") {
    return (
      <div className="tw-border-b container tw-border-gray-200 tw-pb-8">
        <div
          style={{
            backgroundColor: `lightslategray`
          }}
        >
          <ul className="container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw--mb-px tw-text-sm tw-text-md tw-text-center tw-text-white">
            <NavItem
              to="/speciality-breads-total-hours-report"
              pathName="Total Hours Report"
              display={true}
            />
            <NavItem
              to="/speciality-breads-absences-report"
              pathName="Absences Report"
              display={true}
            />
          </ul>
        </div>
      </div>
    );
  }
  return <></>;
};
export default SubMenu;
